import { render, staticRenderFns } from "./AddInsuranceData.vue?vue&type=template&id=38b994a4&scoped=true"
import script from "./AddInsuranceData.vue?vue&type=script&lang=js"
export * from "./AddInsuranceData.vue?vue&type=script&lang=js"
import style0 from "./AddInsuranceData.vue?vue&type=style&index=0&id=38b994a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b994a4",
  null
  
)

export default component.exports